module.exports = __SPARKY_LIBS__.PanWDSReactFormV5;